import { atom } from 'recoil';
import { downloadOverviewVideo } from '../../api/OverviewApi';

const overviewVideoState = atom<Blob | undefined>({
  key: 'overviewVideoState',
  default: downloadOverviewVideo(),
});

export default overviewVideoState;
